import React from 'react';
import { conversionTypes } from '@dotone/react-ui-core/constants';
import { compact } from 'lodash';
import { getNameWithId } from '@dotone/react-ui-core/utils';
import {
  Text,
  FlexContainer,
  Date,
  DateRange,
  Currency,
  Percentage,
  CampaignStatusBadge,
  DetailsBlock,
} from '@dotone/react-ui-core';
import CampaignStatusDropdown from './CampaignStatusDropdown';

export const formatOfferName = (cell) => getNameWithId(cell);

export const formatCampaignApprovalStatus = (cell, row, { t, currentUser }) => (
  <>
    {currentUser.pro ? (
      <CampaignStatusDropdown campaign={row} value={cell} />
    ) : (
      <CampaignStatusBadge value={cell} block />
    )}
    {row.createdAt && (
      <FlexContainer>
        <strong className="mr-1 text-xs text-nowrap">{t('campaign:model.joinDate')}:</strong>
        <Date value={row.createdAt} className="text-nowrap text-xs" />
      </FlexContainer>
    )}
  </>
);

const Payout = ({ convType, value, dates, muted = false, className }) => {
  return (
    <div className={className} style={{ opacity: muted ? '50%' : '100%' }}>
      <FlexContainer justify="left" className="text-md font-weight-bold">
        <Text className="text-uppercase mr-1">{convType}</Text>
        {convType === conversionTypes.CPS ? (
          <Percentage value={value} />
        ) : (
          <Currency value={value} />
        )}
      </FlexContainer>
      {dates && (
        <div className="text-xs text-nowrap">
          (<DateRange values={compact(dates)} className="d-inline-block" />)
        </div>
      )}
    </div>
  );
};

export const formatDefaultPayouts = (cell, { t }) => {
  const { type, originalValue, startsAt, endsAt } = cell || {};

  return (
    <DetailsBlock
      label={t('campaign:model.defaultPayouts')}
      labelProps={{ className: 'mb-1 text-nowrap', spanStyle: { fontSize: '10px' } }}
      contentProps={{ className: 'text-md font-weight-bold' }}
    >
      {(cell &&
        (type === 'limited' ? (
          <>
            <Payout {...cell} dates={[startsAt, endsAt]} className="text-danger" />
            <Payout muted {...cell} value={originalValue} />
          </>
        ) : (
          <Payout {...cell} />
        ))) ||
        t('common:na')}
    </DetailsBlock>
  );
};

export const formatCustomPayouts = (cell, { t }) => {
  const { type, startsAt, endsAt } = cell || {};

  return (
    <DetailsBlock
      label={t('campaign:model.customPayouts')}
      labelProps={{ className: 'mb-1 text-nowrap', spanStyle: { fontSize: '10px' } }}
      contentProps={{ className: 'text-md font-weight-bold' }}
    >
      {(cell &&
        (type === 'limited' ? (
          <Payout {...cell} dates={[startsAt, endsAt]} className="text-danger" />
        ) : (
          <Payout {...cell} className="text-danger" />
        ))) ||
        t('common:na')}
    </DetailsBlock>
  );
};
